
import React, { useState, useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import logo from "../../Images/statixtradinglogo.jpg";
import { FaMoneyBillWave } from "react-icons/fa";

import {
  FaTachometerAlt,
  FaUserCog,
  FaUsers,
  FaWallet,
  FaExchangeAlt,
  FaSignOutAlt,
  FaBars,
    FaEnvelopeOpenText,
  FaTimes
} from "react-icons/fa";
import { FaHistory } from "react-icons/fa";

function Sidebar() {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(null);
  const [open, setOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true);
        setOpen(false);
      } else {
        setIsMobile(false);
        setOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    document.body.style.overflowX = "hidden";

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/admin-login");
    window.location.reload();
  };

  const menuItems = [
    { id: 1, label: "Dashboard", icon: <FaTachometerAlt size={26} />, path: "/admin/dashboard" },
    { id: 2, label: " Profile", icon: <FaUserCog size={26} />, path: "/admin/manageprofile" },
    { id: 3, label: "View Users", icon: <FaUsers size={26} />, path: "/admin/viewusers" },
    { id: 4, label: "payment", icon: <FaHistory  size={26} />, path: "/admin/payment_history" },
    { id: 5, label: "User wallet", icon: <FaWallet size={26} />, path: "/admin/user_wallet"  },
    { id: 6, label: "Transactions", icon: <FaExchangeAlt size={26} />, path: "/admin/transaction" },
    { id: 7, label: "Withdraw", icon: <FaMoneyBillWave size={26} />, path: "/admin/withdraw" },
    {
  id: 8,
  label: "site inquiry",
  icon: <FaEnvelopeOpenText size={26} />,
  path: "/admin/site_inquiry"
}

  ];

  const itemStyle = (index) => ({
    padding: "16px 14px",
    marginBottom: "12px",
    borderRadius: "10px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "14px",
    background: hovered === index ? "#a8aeb6" : "#ebf2f8",
    boxShadow: hovered === index
      ? "0 4px 10px rgba(0,0,0,0.2)"
      : "0 2px 5px rgba(0,0,0,0.1)",
    transition: "all 0.3s ease",
  });

  return (
    <div style={{ display: "flex" }}>


      {isMobile && (
        <div style={styles.topbar}>
          <FaBars size={22} onClick={() => setOpen(!open)} style={{ cursor: "pointer" }} />
          <span style={{ fontWeight: "600" }}>Admin Panel</span>
        </div>
      )}


      {isMobile && open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            background: "rgba(0,0,0,0.4)",
            zIndex: 998,
          }}
        />
      )}
      

      <div
        style={{
          ...styles.sidebar,
    width: isMobile ? "260px" : "270px",
          left: isMobile ? (open ? "0" : "-260px") : "0"
        }}
      >

        {/* {isMobile && open && (
          <div
            onClick={() => setOpen(false)}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              cursor: "pointer",
              fontSize: "20px",
              color: "black",
              background: "#eee",
              borderRadius: "50%",
              padding: "5px",
              zIndex: 1200
            }}
          >
            <FaTimes />
          </div>
        )} */}

<div
  style={{
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-between",
  }}
>

  <div>

<div
  style={{
    width: "160px",
    height: "100px",
    margin: "0 auto 25px",
    borderRadius: "12px",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: "1px solid #e2e8f0",
  }}
>
  <img
    src={logo}
    alt="Logo"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block",
    }}
  />
</div>
    <ul
      style={{
        listStyle: "none",
        padding: 0,
        margin: 0,
      }}
    >

      {menuItems.map((item) => (

        <li
          key={item.id}
          style={itemStyle(item.id)}
          onMouseEnter={() =>
            setHovered(item.id)
          }
          onMouseLeave={() =>
            setHovered(null)
          }
          onClick={() =>
            isMobile && setOpen(false)
          }
        >

          <Link
            to={item.path}
            style={styles.link}
          >
            {item.icon}
            {item.label}
          </Link>

        </li>

      ))}

    </ul>

  </div>

  <div
    style={{
      marginTop: "20px",
      paddingBottom: "10px",
    }}
  >

    <button
      onClick={() =>
        setShowLogoutModal(true)
      }
      style={styles.logout}
    >
      <FaSignOutAlt size={20} />
      Logout
    </button>

  </div>

</div>
      </div>

      <div
        style={{
          ...styles.main,
     marginLeft: isMobile ? "0" : "270px",
          marginTop: isMobile ? "60px" : "0px",
          overflowX: "hidden"
        }}
      >
        <Outlet />
      </div>

  
      {showLogoutModal && (
        <>
         <div
  className="modal fade show"
  style={{
    display: "block",
    zIndex: 2000
  }}
>
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content" style={{ borderRadius: "12px" }}>

                <div
                  className="modal-body"
                  style={{ textAlign: "center", padding: "25px" }}
                >
                  <FaSignOutAlt size={28} color="red" style={{ marginBottom: "10px" }} />

                  <h5 style={{ marginBottom: "10px" }}>Logout</h5>
                  <p style={{ fontSize: "14px", color: "#555" }}>
                    Are you sure you want to logout?
                  </p>

                  <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
                    <button
                      className="btn btn-light w-100"
                      onClick={() => setShowLogoutModal(false)}
                      style={{ borderRadius: "6px" }}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn btn-danger w-100"
                      onClick={handleLogout}
                      style={{ borderRadius: "6px" }}
                    >
                      Logout
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>

      <div
  className="modal-backdrop fade show"
  style={{
    zIndex: 1999
  }}
></div>
        </>
      )}
    </div>
  );
}

const styles = {
  topbar: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    padding: "15px",
    background: "#ebf2f8",
    color: "#0c0c0c",
    position: "fixed",
    width: "100%",
    top: 0,
    zIndex: 1000
  },

sidebar: {
  position: "fixed",
  top: 0,
  left: 0,
  height: "100vh",
  background: "#fff",
  color: "white",
  padding: "20px 15px 90px 15px",
  overflowY: "auto",
  overflowX: "hidden",
  transition: "0.3s ease",
   zIndex: 1000,
  fontSize: "26px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  boxShadow: "2px 0 10px rgba(0,0,0,0.1)",
},
  main: {
    width: "100%",
    padding: "20px",
    minHeight: "100vh",
    background: "#f5f6fa"
  },

link: {
  color: "black",
  textDecoration: "none",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  width: "100%",
  fontSize: "16px",
  fontWeight: "bold",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
},

logout: {
  background: "#fff",
  border: "none",
  color: "red",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  width: "100%",
  cursor: "pointer",
  fontSize: "15px",
  fontWeight: "600",
  padding: "12px",
  borderRadius: "8px",
  whiteSpace: "nowrap",
},
};

export default Sidebar;